/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Tim Porritt
 * Created: 20/04/22
 */

import React from 'react';
import { Column, ListTable } from '@/components/pages/dashboard/tiles/bottomTile/bottomTileTables/ListTable';
import { User } from '@/wpt-lib/interfaces/User';
import Icons from '@/components/icons/Icons';
import { UserWithAutoAssigned } from '@/components/pages/Admin/Supervisor/SupervisorEditor';
import { formatFirstName, formatName } from '@/wpt-lib/utils/formatName';

interface SupervisorListTableProps {
    supervisors: UserWithAutoAssigned[];
    actionsDisabled?: boolean;
    onRemove(user: User): void;
}

const SupervisorListTableColumns: Column<UserWithAutoAssigned>[] = [
    {
        name: 'NEO',
        getData: (user) => (user.isAutoAssigned ? 'Yes' : 'No'),
    },
    {
        name: 'Staff Id',
        getData: (user) => user.staffId,
    },
    {
        name: 'Preferred Name',
        getData: (user) => formatFirstName(user),
    },
    {
        name: 'Last Name',
        getData: (user) => user.lastName,
    },
];

const SupervisorListTable = (props: SupervisorListTableProps) => {
    return (
        <ListTable
            tableCaption="Supervisors"
            columns={SupervisorListTableColumns}
            getActions={(user) =>
                user.isAutoAssigned
                    ? []
                    : [
                          {
                              id: 'remove',
                              label: 'Remove',
                              icon: <Icons.DeleteIcon />,
                              event: (user) => {
                                  props.onRemove(user);
                              },
                              ariaLabel: `Remove ${formatName(user)}`,
                              isDisabled: () => !!props.actionsDisabled,
                          },
                      ]
            }
            data={props.supervisors}
        />
    );
};

export default SupervisorListTable;
